import { FortemSDKError, buildUrl, mergeHeaders, setAuthorizationHeader } from '../shared';
export const createStreamClient = ({ baseUrl = '', getToken, }) => {
    return {
        stream: ({ path, params, onEvent, onComplete, onError, }) => {
            const controller = new AbortController();
            void (async () => {
                try {
                    const headers = mergeHeaders();
                    headers.set('Accept', 'text/event-stream');
                    const token = await getToken?.();
                    setAuthorizationHeader(headers, token);
                    const response = await fetch(buildUrl(path, baseUrl, params), {
                        method: 'GET',
                        headers,
                        signal: controller.signal,
                    });
                    if (!response.ok) {
                        throw new FortemSDKError(response.statusText || `Stream failed (${response.status})`, 'HTTP_ERROR', response.status);
                    }
                    if (!response.body) {
                        throw new FortemSDKError('Missing response body', 'STREAM_MISSING_BODY', 0);
                    }
                    await consumeSseStream({
                        body: response.body,
                        onEvent,
                        onComplete,
                    });
                }
                catch (error) {
                    if (controller.signal.aborted) {
                        return;
                    }
                    onError?.(error instanceof Error ? error : new Error('Stream failed'));
                }
            })();
            return () => controller.abort();
        },
    };
};
export const consumeSseStream = async ({ body, onEvent, onComplete, }) => {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    while (true) {
        const { value, done } = await reader.read();
        if (done) {
            break;
        }
        buffer += decoder.decode(value, { stream: true });
        const messages = buffer.split('\n\n');
        buffer = messages.pop() ?? '';
        for (const message of messages) {
            const event = parseSseMessage(message);
            if (!event) {
                continue;
            }
            onEvent?.(event);
            if (event.event_type === 'STREAM_COMPLETED') {
                onComplete?.(event);
                return;
            }
        }
    }
};
export const parseSseMessage = (message) => {
    const dataLines = message.split('\n').filter((line) => line.startsWith('data:'));
    if (!dataLines.length) {
        return null;
    }
    const json = dataLines.map((line) => line.replace(/^data:\s?/, '')).join('\n');
    return JSON.parse(json);
};
